export const API_CONSTANTS = {
 BASE_URL: "https://backend-o3dyulj4pa-el.a.run.app/v1",
//BASE_URL: "https://posibleapi-uat-789032243296.asia-south1.run.app/v1",
//  BASE_URL: "http://localhost:4000/v1",

};
